<template>
  <base-container
    title="Latest News"
    viewLink="/news"
    :withGradient="articles.length > 1"
    header-central
    no-padding
  >
    <base-scroll-list>
      <ol v-if="articles.length > 0" role="list">
        <li v-for="(article, index) in articles" :key="index" role="listitem">
          <card-list
            v-bind="article"
            @click="handleNewsClick(article)"
          ></card-list>
        </li>
      </ol>
      <p v-else role="article">There are no articles</p>
    </base-scroll-list>
  </base-container>
</template>

<script>
/**
 * # Dashboard news widget
 * ---
 * A widget to display news relevant to the user, as well as news items tagged against user group 13 (MFT Trust)
 *
 */
import {
  BaseContainer,
  BaseScrollableList as BaseScrollList,
} from "@/components/Containers";

const CardList = () => import("@/components/Containers/BaseCardList");

export default {
  name: "NewsWidget",
  components: {
    BaseContainer,
    BaseScrollList,
    CardList,
  },

  data() {
    return {
      postLimit: 10,
      articles: [],
    };
  },

  computed: {
    storeItems() {
      return this.$store.state.widgets.news.articles;
    },
  },

  props: {
    limit: {
      type: [Number, String],
      default: 10,
    },
  },

  /**
   * When mounted we need to get the news items.  We also need to read the users interest group id's
   * TODO: Should these be put in state or just read from the user object
   */
  async mounted() {
    await this.$store.dispatch("widgets/news/setLimit", this.limit);
    await this.$store.dispatch("widgets/news/getLargestLimit");
    this.$store
      .dispatch("widgets/news/getNewsItems", {
        size: this.limit,
        skipState: false,
      })
      .then((resp) => {
        this.articles = resp.slice(0, this.limit);
      });
  },

  methods: {
    handleNewsClick(article) {
      this.$router.push({
        name: "NewsRead",
        params: { id: article.id },
      });
    },
  },

  watch: {
    storeItems: {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.articles = newVal.slice(0, this.limit);
      },
    },
    limit: {
      immediate: false,
      deep: false,
      handler(newValue, oldValue) {
        if (newValue !== this.postLimit) {
          this.postLimit = newValue;
          this.$store
            .dispatch("widgets/news/setLimit", this.postLimit)
            .then(() => {
              this.$store.dispatch("widgets/news/clearCache").then(() => {
                this.$store
                  .dispatch("widgets/news/getNewsItems", {
                    size: this.postLimit,
                  })
                  .then((resp) => {
                    this.articles = resp.slice(0, this.limit);
                  });
              });
            });
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped></style>
